import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { blogApi } from "./blogApi";

export const useBlogCategories = () => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.BLOG_CATEGORIES(),
    queryFn: () => blogApi.fetchBlogCategories(),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.BLOG_CATEGORIES(),
    });
  };

  return {
    isLoading,
    isFetching,
    categories: data?.data ?? [],
    invalidate,
  };
};
